export const municipios = [

  {
    name: "Abalá",
    id: "abala",
    path:
      "M167.387,253.547l-1.208-2.07l-0.173-4.487l-4.832-3.451l-0.345-12.425h16.394l-0.173-8.11h-8.283l-0.518-10.872l24.677,0.172l5.177,4.832l14.84-5.522l0.345,26.058l5.177,0.172l0.173,7.075l-14.323,0.172v8.284L167.387,253.547z",
  },
  {
    name: "Acanceh",
    id: "acanceh",
    path:
      "M242.625,170.026l-11.217,11.734l12.942,11.389l-0.172,8.801l21.743,0.69l-0.173-12.252l-2.761-3.451L242.625,170.026z",
  },
  {
    name: "Akil",
    id: "akil",
    path:
      "M258.197,311.016l0.244,21.476l12.446,8.542l14.398-25.625l-7.321-4.393H258.197z",
  },
  {
    name: "Baca",
    id: "baca",
    path:
      "M259.105,110.06h11.734v17.86l-1.726-0.086l-0.086-2.847l-10.095-0.086L259.105,110.06z",
  },
  {
    name: "Bokobá",
    id: "bokoba",
    path:
      "M328.907,158.896l0.259-21.916l-3.364,0.259l-11.563,10.009v2.761l2.934,0.086v8.887L328.907,158.896z",
  },
  {
    name: "Buctzotz",
    id: "buctzotz",
    path:
      "M413.043,87.96l31.969,0.122V75.88l35.143,0.122l0.122-3.905l55.397,0.122l-0.244,23.794l-16.351,0.122l-0.122,27.211l-1.464-0.366l-6.956-5.979h-97.373L413.043,87.96z",
  },
  {
    name: "Cacalchén",
    id: "cacalchen",
    path:
      "M296.034,148.024l15.53,0.173l1.381,3.02l2.071,1.036l-0.259,6.644l-19.328,0.086l-9.232-8.197l-0.086-0.777l9.75-0.086L296.034,148.024z",
  },
  {
    name: "Calotmul",
    id: "calotmul",
    path:
      "M559.346,134.816l57.595-0.244l-0.244,30.993l-57.351,0.244V134.816z",
  },
  {
    name: "Cansahcab",
    id: "cansahcab",
    path:
      "M323.04,104.02l34.082,0.086l-0.173,19.759h-9.922l-0.087-2.934h-22.951l-0.862-5.436L323.04,104.02z",
  },
  {
    name: "Cantamayec",
    id: "cantamayec",
    path:
      "M321.648,270.017l60.767,0.243v42.464l-34.41,0.732l-0.244-7.565l-26.601-0.244L321.648,270.017z",
  },
  {
    name: "Celestún",
    id: "celestun",
    path:
      "M17.815,199.732h41.731v-79.314l-6.833,1.464l-4.881,1.22l-6.589,1.708l-2.928,0.976l-4.637,3.417l-5.125,3.661l-2.685,3.905l-0.732,1.464l-8.785,10.005l-2.197,3.905l-0.488,4.393v3.904l-7.81,18.303l11.958,0.488V199.732z",
  },
  {
    name: "Cenotillo",
    id: "cenotillo",
    path:
      "M427.319,119.076l0.244,17.815l5.49,0.122l1.099,12.812l20.987,0.366l-0.122,25.625l58.814,0.122l0.244-18.059h4.881v-31.36l-9.029-7.199L427.319,119.076z",
  },
  {
    name: "Conkal",
    id: "conkal",
    path:
      "M224.075,119.033l17.774,0.086l0.259,7.938h7.679l1.208,5.608l-0.259,3.969l-1.122,1.122l0.086,3.192l-11.648,0.086L224.075,119.033z",
  },
  {
    name: "Cuncunul",
    id: "cuncunul",
    path:
      "M527.184,230.165h14.668l0.346,4.832l5.091,0.086l0.172-0.949h1.726l-0.172,5.953l-13.201,10.786l-8.629,0.086V230.165z",
  },
  {
    name: "Cuzamá",
    id: "cuzama",
    path:
      "M247.457,204.366l40.38,0.863l-0.173,28.646l-12.597-1.036l-0.172-12.77L247.457,204.366z",
  },
  {
    name: "Chacsinkín",
    id: "chacsinkin",
    path:
      "M359.475,361.532h6.59l0.731-33.678h7.81v-12.69l-11.958-0.244l-3.416,1.709L359.475,361.532z",
  },
  {
    name: "Chankom",
    id: "chankom",
    path:
      "M474.552,244.056l29.336,0.172l-0.173,15.703l-25.366,30.026h-12.252l0.172-38.137L474.552,244.056z",
  },
  {
    name: "Chapab",
    id: "chapab",
    path:
      "M226.059,262.348h28.818l0.69,29.336l-22.434-0.172l-0.172-7.594l-6.73-0.172L226.059,262.348z",
  },
  {
    name: "Chemax",
    id: "chemax",
    path:
      "M644.873,272.529l-32.787-38.827l12.425-37.274l87.835-43.659l30.889,11.217l-47.973,78.862L644.873,272.529z",
  },
  {
    name: "Chicxulub Pueblo",
    id: "chicxulub-pueblo",
    path:
      "M224.764,100.407l14.154-0.488l0.256,10.055l2.934,2.847l-0.086,3.192h-19.068l-0.69-10.613l1.812-2.674L224.764,100.407z",
  },
  {
    name: "Chichimilá",
    id: "chichimila",
    path:
      "M557.149,242.195l10.494,0.244l20.987,65.892l-31.237,18.06L557.149,242.195z",
  },
  {
    name: "Chikindzonot",
    id: "chikindzonot",
    path:
      "M446.843,320.777l19.279-0.732l0.244-27.088l59.546-0.244l-5.125,8.053h-12.934l-5.125,59.303l-30.262,15.619L446.843,320.777z",
  },
  {
    name: "Chocholá",
    id: "chochola",
    path:
      "M133.047,193.149l22.779,0.173l-0.173,28.473H133.22L133.047,193.149z",
  },
  {
    name: "Chumayel",
    id: "chumayel",
    path:
      "M279.209,270.113h19.672l-0.172,21.57l-19.155-0.172L279.209,270.113z",
  },
  {
    name: "Dzán",
    id: "dzan",
    path:
      "M233.305,294.177l22.452,0.243v14.399l-12.446,0.243l-10.005-7.809V294.177z",
  },
  {
    name: "Dzemul",
    id: "dzemul",
    path:
      "M266.094,85.125h30.803l0.172,16.825h-14.754v-7.938l-0.863-1.122l-15.445,0.173L266.094,85.125z",
  },
  {
    name: "Dzidzantún",
    id: "dzidzantun",
    path:
      "M355.204,60.14l24.038-3.051l0.61,29.896l6.833,0.244l0.122,8.663h-7.81l-0.243,5.857l-23.795,0.122L355.204,60.14z",
  },
  {
    name: "Dzilam de Bravo",
    id: "dzilam-de-bravo",
    path:
      "M382.293,72.952c-0.122-0.61-0.122-16.717-0.122-16.717l25.747-2.074l12.08-3.051l39.534-15.13l2.807-1.708l14.033-10.982l1.586-0.122v50.639L382.293,72.952z",
  },
  {
    name: "Dzilam González",
    id: "dzilam-gonzalez",
    path:
      "M382.171,75.026l60.767,0.366l-0.122,10.616l-31.97,0.122l-0.122,15.741h-29.65l0.122-3.661h7.931l-0.244-13.3h-6.955L382.171,75.026z",
  },
  {
    name: "Dzitas",
    id: "dzitas",
    path:
      "M475.156,177.964l-0.087,26.23l-20.018,0.086l0.087,8.456l10.699,8.283l22.174-0.172v-0.776l13.029-0.086v-27.956l12.855-6.126l0.173-7.852L475.156,177.964z",
  },
  {
    name: "Dzoncauich",
    id: "dzoncauich",
    path:
      "M389.126,119.198l35.631,0.122l0.244,17.571l-21.354,0.122l0.122,2.928l-11.714-0.122l-0.122-8.175l-2.807-0.122V119.198z",
  },
  {
    name: "Espita",
    id: "espita",
    path:
      "M557.638,185.821l-1.464-58.57l-35.143-0.244l-0.244,33.19h-4.393v25.868L557.638,185.821z",
  },
  {
    name: "Halachó",
    id: "halacho",
    path:
      "M14.643,241.219H58.57l21.964,9.03l0.244,9.273l39.047,0.244l0.488,27.333l-8.297,3.66l-14.887-17.326l-7.321,14.154l-43.195-12.69l4.637-14.643l-37.338-5.125L14.643,241.219z",
  },
  {
    name: "Hocabá",
    id: "hocaba",
    path:
      "M296.121,189.008h13.632l0.173,7.248h16.048v6.902l-30.026-0.172L296.121,189.008z",
  },
  {
    name: "Hoctún",
    id: "hoctun",
    path:
      "M318.209,161.225l-6.04,10.009l0.345,9.318l2.934,5.177h13.806l-0.518-24.677L318.209,161.225z",
  },
  {
    name: "Homún",
    id: "homun",
    path:
      "M275.413,236.118h14.668l0.173-30.889h14.15l5.35,12.425l-11.389,23.986l-23.124,0.172L275.413,236.118z",
  },
  {
    name: "Huhí",
    id: "huhi",
    path:
      "M300.952,241.468h55.911l-0.346-18.292l-10.009-9.318l-35.203,0.172l0.69,6.558L300.952,241.468z",
  },
  {
    name: "Hunucmá",
    id: "hunucma",
    path:
      "M61.255,119.686l0.976,27.577l70.772,0.976l0.244,6.833h13.422l10.005,8.786l6.101-11.226l0.977-1.708l-0.488-12.934l-18.059-0.488l-0.488-32.213l-16.351-10.982l-10.25,5.369l-9.273,4.393l-6.101,1.708l-11.958,0.732l-8.054,2.685l-8.786,3.66l-7.321,3.661L61.255,119.686z",
  },
  {
    name: "Ixil",
    id: "ixil",
    path:
      "M225.251,71.854l19.036-2.44l18.303-1.22l0.244,24.648h-5.857l-0.244,14.887l-13.178,3.661l-2.685-2.685V97.722l-15.375-0.244L225.251,71.854z",
  },
  {
    name: "Izamal",
    id: "izamal",
    path:
      "M331.166,187.042l0.244-25.991l43.439-0.244l1.83-4.515h25.259l-1.099,5.735l10.25,0.244l-7.199,19.035l-35.02-0.244l0.122,12.568l-17.938,0.244l-0.122-6.711L331.166,187.042z",
  },
  {
    name: "Kanasín",
    id: "kanasin",
    path:
      "M214.325,166.057l11.217-10.526L240.9,168.3l-11.907,11.389L214.325,166.057z",
  },
  {
    name: "Kantunil",
    id: "kantunil",
    path:
      "M350.823,196.083l-0.173,5.35l-3.451-0.172l-0.172,10.354l12.252,10.354h32.787l-0.173-13.632l-21.57-12.08L350.823,196.083z",
  },
  {
    name: "Kaua",
    id: "kaua",
    path:
      "M507.856,244.143l9.232-0.086l0.173-13.892l7.679-0.086v28.991l-18.032-0.259l-0.604-0.604l0.173-13.287L507.856,244.143z",
  },
  {
    name: "Kinchil",
    id: "kinchil",
    path:
      "M62.475,161.173h69.308l-0.244,17.571H89.563l-10.494,9.274l-0.732,11.714l-15.863-0.244V161.173z",
  },
  {
    name: "Kopomá",
    id: "kopoma",
    path:
      "M118.034,224.039h37.792l0.345,8.11h1.553l0.345,12.77l5.867,3.624l-0.518,3.105l-14.496-10.871h-5.867l-0.172-7.766h-24.677L118.034,224.039z",
  },
  {
    name: "Mama",
    id: "mama",
    path:
      "M257.121,262.176h13.287l6.385,6.557l0.173,22.779l-18.81,0.172L257.121,262.176z",
  },
  {
    name: "Maní",
    id: "mani",
    path:
      "M258.197,294.42l18.792-0.243v14.643h-18.547L258.197,294.42z",
  },
  {
    name: "Maxcanú",
    id: "maxcanu",
    path:
      "M17.327,202.172l-1.708,36.606h43.928l22.94,10.006l0.244,8.053h37.095l-0.244-15.619l21.231-0.244l-0.488-5.613l-24.648-0.244l0.488-13.178l14.886-0.244v-19.523H17.327z",
  },
  {
    name: "Mayapán",
    id: "mayapan",
    path:
      "M301.125,269.941l17.946,0.172l-0.345,21.57h-17.429L301.125,269.941z",
  },
  {
    name: "Mérida",
    id: "merida",
    path:
      "M174.29,105.142h18.464l0.172,3.969h27.956v6.212l-0.518,3.278l16.221,22.951l0.345,7.593l5.004,11.562l-10.872-8.11l-3.278,2.416l-3.279-1.898l-14.323,12.597l0.345,1.553l10.354,8.283v1.208l-3.106,1.898l0.172,23.814l-4.832,5.867l-13.805,5.867l-4.66-3.624l-3.106-5.35l-1.035-2.416l8.973-27.955l-8.801-10.699l-9.318-0.345l-0.345-12.77l-1.898-0.173l-0.172-20.535l-4.659-1.726V105.142z",
  },
  {
    name: "Mocochá",
    id: "mococha",
    path:
      "M244.092,124.814h12.856v-13.805h-4.832l-7.679,2.761l-0.518,3.192l-0.69,0.863L244.092,124.814z",
  },
  {
    name: "Motul",
    id: "motul",
    path:
      "M259.019,95.047l0.172,12.856l13.805-0.086l0.086,20.104l22.778,0.172l0.173,17.947l16.135-0.086l11.562-10.44l-0.086-2.416l-0.69-0.086l-1.898-16.825l-0.086-12.252l-40.984,0.086v-8.973H259.019z",
  },
  {
    name: "Muna",
    id: "muna",
    path:
      "M167.657,257.326l35.63-0.244l-0.732,38.803l-35.386,0.244L167.657,257.326z",
  },
  {
    name: "Muxupip",
    id: "muxupip",
    path:
      "M272.997,129.991h20.19v18.033l-20.104-0.172L272.997,129.991z",
  },
  {
    name: "Opichén",
    id: "opichen",
    path:
      "M123.242,286.855l-0.976-43.684l26.112,0.244l16.107,13.422l-0.244,29.041L123.242,286.855z",
  },
  {
    name: "Oxkutzcab",
    id: "oxkutzcab",
    path:
      "M164.729,355.676l16.839-16.596l33.922,0.244l40.023-26.844v20.499l14.398,10.249l-4.393,8.299l-18.547,7.076l-16.595,79.314L164.729,355.676z",
  },
  {
    name: "Panabá",
    id: "panaba",
    path:
      "M480.276,42.08l105.671,0.244l11.47,11.47h-7.81l0.244,41.731h-51.737l0.244-25.625l-58.326,0.244L480.276,42.08z",
  },
  {
    name: "Peto",
    id: "peto",
    path:
      "M368.993,435.233l101.521-58.082l-26.356-55.886h-35.143l-0.732,28.797l-39.29-0.244V435.233z",
  },
  {
    name: "Progreso",
    id: "progreso",
    path:
      "M131.783,92.353l37.827-15.13l13.91-0.244l38.803-4.637v27.577l-1.953,7.077l-24.892-0.244l-0.244-3.905l-48.321,0.976L131.783,92.353z",
  },
  {
    name: "Quintana Roo",
    id: "quintana-roo",
    path:
      "M455.139,178.05l17.86,0.086v23.9h-17.947L455.139,178.05z",
  },
  {
    name: "Rio Lagartos",
    id: "rio-lagartos",
    path:
      "M576.186,8.158l5.612,31.726l4.881,0.244l14.154,13.667l14.399,0.244l0.243-50.517h-18.791h-13.422l-4.881,0.488l-1.953,2.685L576.186,8.158z",
  },
  {
    name: "Sacalum",
    id: "sacalum",
    path:
      "M205.972,247.076h16.839l-0.244,36.119l-16.595,4.393V247.076z",
  },
  {
    name: "Samahil",
    id: "samahil",
    path:
      "M81.266,199.732l0.244-9.762l9.274-8.786l43.195-0.244l0.244-21.963l-2.196-1.708l13.422-0.244l12.446,10.982l-0.244,3.661h-16.107v19.035l-10.982,0.488l-0.244,8.542H81.266z",
  },
  {
    name: "Sanahcat",
    id: "sanahcat",
    path:
      "M307.337,205.229l21.916-0.518v-3.624l15.703,0.173l-0.173,10.354h-35.375L307.337,205.229z",
  },
  {
    name: "San Felipe",
    id: "san-felipe",
    path:
      "M480.276,39.64V22.313l8.054-0.976l10.981-1.221c0,0,4.393-0.488,5.613-0.976c1.22-0.488,8.541-2.684,8.541-2.684l3.173-2.44h41.976c0,0,4.393-1.953,5.612-2.44c1.221-0.488,3.417-2.197,4.394-2.685c0.976-0.488,5.125-0.488,5.125-0.488l4.637,31.237H480.276z",
  },
  {
    name: "Santa Elena",
    id: "santa-elena",
    path:
      "M113.724,292.469l9.762-3.661h41.243l-0.244,9.273l38.315,0.244v38.315h-21.964l-17.815,17.326L113.724,292.469z",
  },
  {
    name: "Seyé",
    id: "seye",
    path:
      "M267.959,165.078l6.589,0.122l8.907,7.687l1.586,0.122l11.348-11.836l4.271,0.122L297,166.176V185.7l-3.172,0.244v16.839l-25.747-0.122L267.959,165.078z",
  },
  {
    name: "Sinanché",
    id: "sinanche",
    path:
      "M310.098,96.168l0.087,5.867h23.728v-5.004h-1.984l-0.087-34.771c0,0-7.334,0-7.679,0.172s-8.11,0.863-8.11,0.863l-0.087,32.787L310.098,96.168z",
  },
  {
    name: "Sotuta",
    id: "sotuta",
    path:
      "M332.014,244.056h27.266v-20.018l36.583,0.172l0.518,43.659l-64.193-0.173L332.014,244.056z",
  },
  {
    name: "Sucilá",
    id: "sucila",
    path:
      "M521.031,98.21l35.631,0.244l-0.244,26.845l-35.387-0.976V98.21z",
  },
  {
    name: "Sudzal",
    id: "sudzal",
    path:
      "M371.189,183.503h28.675l0.244,14.399l23.672,6.101l29.041,0.244l-0.122,7.687l-31.726,0.122l-10.737,9.884h-16.229l0.244-14.155l-23.184-13.544L371.189,183.503z",
  },
  {
    name: "Suma",
    id: "suma",
    path:
      "M326.061,134.996l15.962-0.086l0.173-5.695l2.761-3.624l-0.173-2.761l-19.154,0.432L326.061,134.996z",
  },
  {
    name: "Tahdziú",
    id: "tahdziu",
    path:
      "M369.371,331.316l9.335,0.061l0.044-16.064l27.688,0.5l-0.188,15.813l-0.375,15.438l-8.744,0.055l-9.334-0.061l-9.335-0.061l-9.335-0.061l0.061-3.904l0.061-3.905l0.061-3.905L369.371,331.316L369.371,331.316z",
  },
  {
    name: "Tahmek",
    id: "tahmek",
    path:
      "M303.368,161.225h12.425l-5.867,9.318l0.518,11.734l2.07,3.452l-13.632-0.173l0.173-19.672L303.368,161.225z",
  },
  {
    name: "Teabo",
    id: "teabo",
    path:
      "M279.429,294.42l39.291,0.488v18.548l-31.726,0.731l-7.809-5.125L279.429,294.42z",
  },
  {
    name: "Tecoh",
    id: "tecoh",
    path:
      "M215.015,210.233l4.314-6.212l23.642,0.345l29.854,17.429l-0.172,19.327l-17.947-0.518l-0.69,19.327l-27.61,0.346l-0.863-15.186l-4.314-0.345l-0.345-9.664l-5.695-0.172L215.015,210.233z",
  },
  {
    name: "Tekal de Venegas",
    id: "tekal-de-venegas",
    path:
      "M377.168,133.84l12.69,0.366l0.244,8.053l14.887-0.122l1.342-3.05h24.526l0.488,20.622l-27.455,0.122l-0.244-5.857l-26.479-0.122V133.84z",
  },
  {
    name: "Tekantó",
    id: "tekanto",
    path:
      "M331.064,137.152v21.83L356,158.896l-0.172-16.307l-10.786-0.432l-0.086-5.09L331.064,137.152z",
  },
  {
    name: "Tekax",
    id: "tekax",
    path:
      "M275.413,492.549l35.204-21.053l0.345-43.142l13.46-12.77l0.345-14.841l-18.292-21.742l16.566-15.531l-13.114-15.876l18.637-31.062h-41.07l-20.708,38.309l-18.292,6.213l-15.186,80.76L275.413,492.549z",
  },
  {
    name: "Tekit",
    id: "tekit",
    path:
      "M256.603,244.056h73.34l-0.173,23.641l-50.216,0.346l-8.11-7.766l-14.496-0.346L256.603,244.056z",
  },
  {
    name: "Tekom",
    id: "tekom",
    path:
      "M482.145,289.785l23.642-28.818c0,0,21.397,0.863,21.397,0.174c0-0.691,0.173-8.111,0.173-8.111h8.628l12.425-10.872h6.385l-0.172,11.735l-4.314-0.173l-22.261,35.721L482.145,289.785z",
  },
  {
    name: "Telchac Pueblo",
    id: "telchac-pueblo",
    path:
      "M298.881,85.383l0.173,16.739l9.059-0.259l-0.172-7.938l6.039-0.086l-0.345-8.974L298.881,85.383z",
  },
  {
    name: "Telchac Puerto",
    id: "telchac-puerto",
    path:
      "M265.663,68.127l0.173,14.84l48.145-0.172l-0.086-18.724l-37.964,2.071l-9.577,1.467L265.663,68.127z",
  },
  {
    name: "Temax",
    id: "temax",
    path:
      "M358.987,103.945h51.858l-0.122,12.934l-23.916,0.244l0.122,14.643l-10.006-0.244v-6.589l-17.692-0.122L358.987,103.945z",
  },
  {
    name: "Temozón",
    id: "temozon",
    path:
      "M559.453,168.128h116.309L596.21,207.99h-36.066L559.453,168.128z",
  },
  {
    name: "Tepakán",
    id: "tepakan",
    path:
      "M358.987,127.861l15.74,0.366l0.122,27.333l-2.196,3.295h-13.544l-1.343-2.563v-5.369l3.173-2.318v-10.616l-1.708-0.488L358.987,127.861z",
  },
  {
    name: "Tetiz",
    id: "tetiz",
    path:
      "M62.231,149.703l68.576,0.488l-0.244,4.637l-0.976,0.976l-0.732,2.685l-66.379,0.488L62.231,149.703z",
  },
  {
    name: "Teya",
    id: "teya",
    path:
      "M346.768,126.022l-2.674,4.314l0.086,4.746l3.796,1.036l0.173,3.796l9.06,0.259l-0.259-14.15H346.768z",
  },
  {
    name: "Ticul",
    id: "ticul",
    path:
      "M205.972,290.516l0.488,45.881l8.053,0.244l39.779-25.381l-10.982,0.488l-12.446-9.762l-0.244-15.863h-8.786L205.972,290.516z",
  },
  {
    name: "Timucuy",
    id: "timucuy",
    path:
      "M220.02,180.38l0.345,21.398l21.57,0.172v-8.628l-16.394-13.978l-2.416-1.38L220.02,180.38z",
  },
  {
    name: "Tinum",
    id: "tinum",
    path:
      "M467.132,223.089l35.894-1.035l0.259-28.646l10.354-5.349l19.413,0.259l-0.086,29.595l-18.119,0.259v23.469l-45.471,0.259l-2.243-1.035V223.089z",
  },
  {
    name: "Tixcacalcupul",
    id: "tixcacalcupul",
    path:
      "M510.294,304.182h12.934l28.554-48.076h2.928l0.244,71.993l-49.54,29.772L510.294,304.182z",
  },
  {
    name: "Tixkokob",
    id: "tixkokob",
    path:
      "M257.099,143.114l13.789,0.122v6.833h11.348l11.592,10.494l-9.762,9.64l-9.274-7.565l-6.589,0.244L257.099,143.114z",
  },
  {
    name: "Tixmehuac",
    id: "tixmehuac",
    path:
      "M356.791,316.141v45.636l-30.506,0.244l-12.446-14.887l18.304-30.993l-0.488-1.953l-10.494-0.244v-5.856l24.648,0.244v7.81H356.791z",
  },
  {
    name: "Tixpéhual",
    id: "tixpehual",
    path:
      "M239.162,143.114v5.857l6.711,14.887l-1.22,0.732l-13.422-8.664l-0.732,0.61l34.776,29.651l0.61-0.122v-21.598l-11.47-21.354H239.162z",
  },
  {
    name: "Tizimín",
    id: "tizimin",
    path:
      "M559.281,98.066l32.96,0.173V56.996l26.057-0.69l-0.173-53.322l13.461,0.863l7.938,1.38l5.694,1.726l5.005,1.553l7.766,3.279l6.039,3.796l5.522,2.588l7.766,2.588l11.734,2.761l11.734,2.761l7.593,2.244l16.738,3.796l6.558,2.243l5.004,1.553l7.421,0.69l2.934,1.208l1.726,0.173l0.345,115.791l-5.177,7.42L712,151.044l-31.924,14.84l-61.088-0.172v-33.305l-59.88-0.518L559.281,98.066z",
  },
  {
    name: "Tunkas",
    id: "tunkas",
    path:
      "M402.061,184.113v11.592l24.404,6.223h26.479l-0.488-49.907l-18.303,0.244l-0.122,9.884l-20.378,0.122l-8.785,21.72L402.061,184.113z",
  },
  {
    name: "Tzucacab",
    id: "tzucacab",
    path:
      "M313.377,469.771l52.459-32.098V364.16h-39.689l-16.566,15.187l17.257,20.362l-0.345,17.602l-13.115,12.425V469.771z",
  },
  {
    name: "Uayma",
    id: "uayma",
    path:
      "M517.176,219.983l17.86-0.086l0.259-31.062l22.778,0.172l-0.087,20.018l-11.82,14.409l-0.173,2.502l0.949,0.172l2.243,5.263l-0.431,0.69l-1.813,0.776h-2.675l-0.172-4.832h-27.007L517.176,219.983z",
  },
  {
    name: "Ucú",
    id: "ucu",
    path:
      "M147.025,105.832l24.677-0.518l0.518,25.54l4.659,1.726v18.119l-10.872-0.172l0.173-15.531l-18.982-0.173L147.025,105.832z",
  },
  {
    name: "Umán",
    id: "uman",
    path:
      "M144.091,173.995l0.172,16.911l14.496,0.172l-0.345,37.964l16.566-0.172v-3.796l-8.974-0.173l0.173-15.013l25.539-0.172l-3.624-6.04v-2.761l1.553-4.487l6.902-21.053l-8.801-9.318h-8.973l-0.173-12.597h-13.288l-6.212,13.115l1.035,0.69l-0.172,6.902L144.091,173.995z",
  },
  {
    name: "Valladolid",
    id: "valladolid",
    path:
      "M642.975,274.428l-33.305-39.863l11.217-36.411l-23.642,11.907h-38.31l-10.871,14.668l2.934,6.385l0.345,8.628l18.465,0.518l20.708,66.955L642.975,274.428z",
  },
  {
    name: "Xocchel",
    id: "xocchel",
    path:
      "M312.169,189.008h16.566h19.845l0.345,9.664l-21.053,0.172v-5.004h-13.287l-2.416-0.172V189.008z",
  },
  {
    name: "Yaxcabá",
    id: "yaxcaba",
    path:
      "M384.991,269.941l14.322-0.174l-0.518-45.557l13.46-0.172l10.354-10.009l31.062,0.173l11.044,8.456l0.69,21.57l5.35-0.172l-7.248,5.694l0.345,67.991l-54.875,0.173l-0.173-4.832l-23.813-0.346V269.941z",
  },
  {
    name: "Yaxkukul",
    id: "yaxkukul",
    path:
      "M252.03,140.949l18.896-0.086l0.086-10.699l-3.969-0.086l-0.086-3.02h-15.013l0.173,4.745L252.03,140.949z",
  },
  {
    name: "Yobaín",
    id: "yobain",
    path:
      "M336.069,101.949l0.086-7.161h-2.07v-32.96l15.616-1.726l3.193,0.086l0.086,41.76H336.069z",
  }

]